import React, { useState, useEffect } from 'react';
import { compressFiles, optimizeFormData, validateFormData } from '../../../shared/utils/performanceUtils';
import { apiGet, apiPost, apiPut, apiDelete } from '../../../shared/utils/apiConfig';
import { useTitle } from '../../../context/TitleContext';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft, FaImage } from 'react-icons/fa';
import { showSuccessToast, showErrorToast, showWarningToast, showInfoToast } from '../../../shared/utils/toastHelper';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AdminEditBanner = () => {
    const { setTitle } = useTitle();
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [banner, setBanner] = useState(null);
    const [formData, setFormData] = useState({
        title_ar: '',
        title_en: '',
        description_ar: '',
        description_en: '',
        status: '1',
        image: null,
        type: 'home',
        doctor_id: '',
        product_id: '',
        clinic_id: '',
        category_id: '',
        sub_category_id: '',
        home_action_type: 'none',
        home_action_value: '',
        discountValue: ''
    });
    const [imagePreview, setImagePreview] = useState(null);
    const [imageProcessing, setImageProcessing] = useState(false);
    const [doctors, setDoctors] = useState([]);
    const [pharmacyProducts, setPharmacyProducts] = useState([]);
    const [clinics, setClinics] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [subSubCategories, setSubSubCategories] = useState([]);
    const [pharmacySubCategories, setPharmacySubCategories] = useState([]);
    const [loadingData, setLoadingData] = useState(false);

    const tabs = [
        { key: 'home', label: 'الرئيسية' },
        { key: 'pharmacy', label: 'الصيدليات' },
        { key: 'clinic', label: 'العيادات' },
        { key: 'doctor', label: 'الأطباء' },
        { key: 'sub_category', label: 'الفئات الفرعية' }
    ];


    useEffect(() => {
        setTitle('تعديل البانر');
        fetchBanner();
    }, [setTitle, id]);

    const getAuthToken = () => {
        const adminData = sessionStorage.getItem('adminkhadamat');
        if (adminData) {
            try {
                const parsed = JSON.parse(adminData);
                // البحث عن التوكن في أماكن مختلفة
                if (parsed.data?.token?.access_token) {
                    return String(parsed.data.token.access_token);
                }
                if (parsed.data?.access_token) {
                    return String(parsed.data.access_token);
                }
                if (parsed.data?.token) {
                    return String(parsed.data.token);
                }
                if (parsed.token) {
                    return String(parsed.token);
                }
                return null;
            } catch {
                return null;
            }
        }
        return null;
    };

    const fetchDoctors = async (search = '') => {
        try {
            setLoadingData(true);
            const token = getAuthToken();
            const url = search ? `${BASE_URL}/doctors/get_all?status=1&search=${encodeURIComponent(search)}` : `${BASE_URL}/doctors/get_all?status=1`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar'
                }
            });
            if (response.data?.result?.data) {
                setDoctors(response.data.result.data);
            }
        } catch (error) {
            showErrorToast('فشل في جلب قائمة الأطباء');
            console.error(error);
        } finally {
            setLoadingData(false);
        }
    };

    const fetchPharmacyProducts = async (search = '') => {
        try {
            setLoadingData(true);
            const token = getAuthToken();
            const body = search ? { search } : {};
            const response = await axios.post(`${BASE_URL}/Pharmacy_products`, body, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar'
                }
            });
            if (response.data?.result) {
                setPharmacyProducts(response.data.result);
            } else if (response.data?.data) {
                setPharmacyProducts(response.data.data);
            } else if (Array.isArray(response.data)) {
                setPharmacyProducts(response.data);
            }
        } catch (error) {
            showErrorToast('فشل في جلب منتجات الصيدليات');
            console.error(error);
        } finally {
            setLoadingData(false);
        }
    };

    const fetchClinics = async (search = '') => {
        try {
            setLoadingData(true);
            const token = getAuthToken();
            const url = search ? `${BASE_URL}/clinics/get_all?status=1&search=${encodeURIComponent(search)}` : `${BASE_URL}/clinics/get_all?status=1`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar'
                }
            });
            if (response.data?.result?.data) {
                setClinics(response.data.result.data);
            }
        } catch (error) {
            showErrorToast('فشل في جلب قائمة العيادات');
            console.error(error);
        } finally {
            setLoadingData(false);
        }
    };

    const fetchCategories = async (search = '') => {
        try {
            setLoadingData(true);
            const token = getAuthToken();
            const url = search ? `${BASE_URL}/admin/categories?search=${encodeURIComponent(search)}` : `${BASE_URL}/admin/categories`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar'
                }
            });
            if (response.data?.data) {
                setCategories(response.data.data);
            } else if (Array.isArray(response.data)) {
                setCategories(response.data);
            }
        } catch (error) {
            showErrorToast('فشل في جلب الفئات');
            console.error(error);
        } finally {
            setLoadingData(false);
        }
    };

    const fetchSubCategories = async (categoryId, search = '') => {
        try {
            setLoadingData(true);
            const token = getAuthToken();
            const url = search ? `${BASE_URL}/admin/category/${categoryId}/sub-categories?search=${encodeURIComponent(search)}` : `${BASE_URL}/admin/category/${categoryId}/sub-categories`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar'
                }
            });
            if (response.data?.data) {
                setSubCategories(response.data.data);
            } else if (Array.isArray(response.data)) {
                setSubCategories(response.data);
            }
            setSubSubCategories([]);
        } catch (error) {
            showErrorToast('فشل في جلب الفئات الفرعية');
            console.error(error);
        } finally {
            setLoadingData(false);
        }
    };

    const fetchPharmacySubCategories = async () => {
        try {
            setLoadingData(true);
            const token = getAuthToken();
            const response = await axios.get(`${BASE_URL}/admin/category/8/sub-categories`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar'
                }
            });
            if (response.data?.data) {
                setPharmacySubCategories(response.data.data);
            } else if (response.data?.status === 'success' || response.data?.status === 200) {
                setPharmacySubCategories(response.data.data || []);
            } else if (Array.isArray(response.data)) {
                setPharmacySubCategories(response.data);
            }
        } catch (error) {
            showErrorToast('فشل في جلب فئات الصيدلية الفرعية');
            console.error(error);
        } finally {
            setLoadingData(false);
        }
    };

    const fetchBanner = async () => {
        try {
            setLoading(true);
            const token = getAuthToken();
            const response = await axios.get(`${BASE_URL}/admin/banners/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                },
            });

            const apiStatus = response.data?.status;
            if (apiStatus === 'success' || apiStatus === 200) {
                const bannerData = response.data.data;
                setBanner(bannerData);
                
                // استخراج البيانات من home_actionable إذا كانت موجودة
                const homeActionable = bannerData.home_actionable || {};
                const homeActionType = homeActionable.type || bannerData.home_action_type || 'none';
                // تحويل actionable_id إلى string للتأكد من التوافق
                const homeActionValue = homeActionable.actionable_id 
                    ? String(homeActionable.actionable_id) 
                    : (bannerData.home_action_value ? String(bannerData.home_action_value) : '');
                const discountValue = homeActionable.discount_value || bannerData.discountValue || '';
                
                // جلب البيانات حسب نوع البانر أولاً
                if (bannerData.type === 'doctor') {
                    await fetchDoctors();
                } else if (bannerData.type === 'pharmacy') {
                    await fetchPharmacyProducts();
                } else if (bannerData.type === 'clinic') {
                    await fetchClinics();
                } else if (bannerData.type === 'sub_category') {
                    await fetchCategories();
                    if (bannerData.category_id) {
                        await fetchSubCategories(bannerData.category_id);
                    }
                } else if (bannerData.type === 'home') {
                    if (homeActionType === 'pharmacy') {
                        await fetchPharmacyProducts();
                    } else if (homeActionType === 'sub_category') {
                        await fetchPharmacySubCategories();
                    }
                }
                
                // تعيين البيانات بعد جلب القوائم
                setFormData({
                    title_ar: bannerData.title_ar || '',
                    title_en: bannerData.title_en || '',
                    description_ar: bannerData.description_ar || '',
                    description_en: bannerData.description_en || '',
                    status: String(bannerData.status ?? '1'),
                    image: null,
                    type: bannerData.type || 'home',
                    doctor_id: bannerData.doctor_id ? String(bannerData.doctor_id) : '',
                    product_id: bannerData.product_id ? String(bannerData.product_id) : '',
                    clinic_id: bannerData.clinic_id ? String(bannerData.clinic_id) : '',
                    category_id: bannerData.category_id ? String(bannerData.category_id) : '',
                    sub_category_id: bannerData.sub_category_id ? String(bannerData.sub_category_id) : '',
                    home_action_type: homeActionType,
                    home_action_value: homeActionValue,
                    discountValue: discountValue
                });
                setImagePreview(bannerData.image || null);
            } else {
                throw new Error(response.data.message || 'فشل في جلب البانر');
            }
        } catch (error) {
            showErrorToast(error.response?.data?.message || 'فشل في جلب البانر');
            navigate('/admin-banners');
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'category_id') {
            setFormData(prev => ({
                ...prev,
                [name]: value,
                sub_category_id: ''
            }));
            if (value) {
                fetchSubCategories(value);
            } else {
                setSubCategories([]);
                setSubSubCategories([]);
            }
        } else if (name === 'sub_category_id') {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        } else if (name === 'home_action_type') {
            setFormData(prev => ({
                ...prev,
                [name]: value,
                home_action_value: ''
            }));
            if (value === 'pharmacy') {
                fetchPharmacyProducts();
            } else if (value === 'sub_category') {
                fetchPharmacySubCategories();
            }
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];

        if (!file) {
            setFormData(prev => ({
                ...prev,
                image: null
            }));
            setImagePreview(banner?.image || null);
            return;
        }

        if (!file.type.startsWith('image/')) {
            showErrorToast('يرجى اختيار صورة صالحة');
            e.target.value = '';
            return;
        }

        setImageProcessing(true);

        try {
            const [compressedResult] = await compressFiles([file], {
                maxSize: 800000,
                quality: 0.85
            });

            const finalFile = compressedResult instanceof File
                ? compressedResult
                : new File([compressedResult], file.name, {
                    type: file.type || 'image/jpeg',
                    lastModified: Date.now()
                });

            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
                setImageProcessing(false);
            };
            reader.onerror = () => {
                setImagePreview(banner?.image || null);
                setImageProcessing(false);
                showErrorToast('حدث خطأ أثناء قراءة الصورة');
            };
            reader.readAsDataURL(finalFile);

            setFormData(prev => ({
                ...prev,
                image: finalFile
            }));
        } catch (error) {
            setImageProcessing(false);
            showErrorToast('فشل في معالجة الصورة، يرجى المحاولة مرة أخرى');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!formData.title_ar.trim()) {
            showErrorToast('يرجى إدخال العنوان العربي للبانر');
            return;
        }

        // التحقق من الحقول المطلوبة حسب نوع البانر
        if (formData.type === 'doctor' && !formData.doctor_id) {
            showErrorToast('يرجى اختيار طبيب');
            return;
        }

        if (formData.type === 'pharmacy' && !formData.product_id) {
            showErrorToast('يرجى اختيار منتج صيدليات');
            return;
        }

        if (formData.type === 'clinic' && !formData.clinic_id) {
            showErrorToast('يرجى اختيار عيادة');
            return;
        }

        if (formData.type === 'sub_category' && !formData.sub_category_id) {
            showErrorToast('يرجى اختيار فئة فرعية');
            return;
        }

        // التحقق من الحقول المطلوبة للرئيسية
        if (formData.type === 'home') {
            if (formData.home_action_type === 'pharmacy' && !formData.home_action_value) {
                showErrorToast('يرجى اختيار منتج صيدليات');
                return;
            }
            if (formData.home_action_type === 'sub_category' && !formData.home_action_value) {
                showErrorToast('يرجى اختيار فئة فرعية للصيدلية');
                return;
            }
        }

        if (imageProcessing) {
            showWarningToast('يرجى الانتظار حتى يتم تجهيز الصورة قبل الإرسال');
            return;
        }

        try {
            setLoading(true);
            const token = getAuthToken();
            const submitData = new FormData();
            submitData.append('title_ar', formData.title_ar.trim());
            if (formData.title_en) submitData.append('title_en', formData.title_en.trim());
            if (formData.description_ar) submitData.append('description_ar', formData.description_ar.trim());
            if (formData.description_en) submitData.append('description_en', formData.description_en.trim());
            submitData.append('status', formData.status);
            submitData.append('type', formData.type);
            
            // إضافة الحقول الخاصة بالرئيسية
            if (formData.type === 'home') {
                if (formData.home_action_type) {
                    submitData.append('home_action_type', formData.home_action_type);
                }
                if (formData.home_action_value) {
                    submitData.append('home_action_value', formData.home_action_value);
                }
                if (formData.discountValue) {
                    submitData.append('discountValue', formData.discountValue);
                }
            }
            
            // إضافة الـ IDs المناسبة حسب نوع البانر
            if (formData.type === 'doctor' && formData.doctor_id) {
                submitData.append('doctor_id', formData.doctor_id);
            } else if (formData.type === 'pharmacy' && formData.product_id) {
                submitData.append('product_id', formData.product_id);
            } else if (formData.type === 'clinic' && formData.clinic_id) {
                submitData.append('clinic_id', formData.clinic_id);
            } else if (formData.type === 'sub_category' && formData.sub_category_id) {
                submitData.append('sub_category_id', formData.sub_category_id);
            }
            
            if (formData.image) {
                submitData.append('image', formData.image);
            }

            const response = await axios.post(`${BASE_URL}/admin/banners/${id}`, submitData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                    'Content-Type': 'multipart/form-data',
                },
            });

            const apiStatus = response.data?.status;
            const responseStatus = response.status;
            if (apiStatus === 'success' || apiStatus === 200 || apiStatus === 201 || responseStatus === 200 || responseStatus === 201) {
                showSuccessToast('تم تحديث البانر بنجاح');
                setTimeout(() => {
                    navigate('/admin-banners');
                }, 1500);
            } else {
                throw new Error(response.data.message || 'فشل في تحديث البانر');
            }
        } catch (error) {
            showErrorToast(error.response?.data?.message || error.message || 'فشل في تحديث البانر');
        } finally {
            setLoading(false);
        }
    };

    if (loading && !banner) {
        return (
            <div className="main_content">
                <div className="dashboard-container">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3 text-muted">جاري تحميل البانر...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!banner) {
        return (
            <div className="main_content">
                <div className="dashboard-container">
                    <div className="text-center py-5">
                        <FaImage className="text-muted" style={{ fontSize: '3rem' }} />
                        <p className="mt-3 text-muted">البانر غير موجود</p>
                        <button className="btn text-white" onClick={() => navigate('/admin-banners')} style={{ backgroundColor: 'rgb(24, 65, 148)' }}>
                            العودة للبانرات
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="main_content">
            <div className="dashboard-container">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="btn btn-outline-secondary d-flex align-items-center"
                        onClick={() => navigate('/admin-banners')}
                        style={{ borderRadius: '8px' }}>
                        <FaArrowLeft className="mx-2" />
                        العودة للبانرات
                    </motion.button>
                    <h4 className="mb-0">تعديل البانر</h4>
                </div>

                {/* Form */}
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">العنوان (عربي) *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="title_ar"
                                        value={formData.title_ar}
                                        onChange={handleInputChange}
                                        placeholder="أدخل العنوان بالعربية"
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">العنوان (إنجليزي)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="title_en"
                                        value={formData.title_en}
                                        onChange={handleInputChange}
                                        placeholder="Enter English title"
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">النوع *</label>
                                    <select
                                        className="form-control"
                                        name="type"
                                        value={formData.type}
                                        onChange={handleInputChange}
                                        required>
                                        {tabs.map((tab) => (
                                            <option key={tab.key} value={tab.key}>
                                                {tab.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">الحالة</label>
                                    <select
                                        className="form-control"
                                        name="status"
                                        value={formData.status}
                                        onChange={handleInputChange}>
                                        <option value="1">نشط</option>
                                        <option value="0">غير نشط</option>
                                    </select>
                                </div>

                                {/* حقول خاصة بالرئيسية */}
                                {formData.type === 'home' && (
                                    <>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">نوع الإجراء</label>
                                            <select
                                                className="form-control"
                                                name="home_action_type"
                                                value={formData.home_action_type}
                                                onChange={handleInputChange}>
                                                <option value="none">لا يوجد</option>
                                                <option value="pharmacy">منتج صيدليات</option>
                                                <option value="sub_category">فئة فرعية للصيدلية</option>
                                            </select>
                                        </div>
                                        {formData.home_action_type === 'pharmacy' && (
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">اختر منتج صيدليات *</label>
                                                <select
                                                    className="form-control"
                                                    name="home_action_value"
                                                    value={formData.home_action_value}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={loadingData}>
                                                    <option value="">-- اختر منتج --</option>
                                                    {pharmacyProducts.map((product) => (
                                                        <option key={product.id} value={product.id}>
                                                            {product.name || product.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                        {formData.home_action_type === 'sub_category' && (
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">اختر فئة فرعية للصيدلية *</label>
                                                <select
                                                    className="form-control"
                                                    name="home_action_value"
                                                    value={formData.home_action_value}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={loadingData}>
                                                    <option value="">-- اختر فئة فرعية --</option>
                                                    {pharmacySubCategories.map((subCategory) => (
                                                        <option key={subCategory.id} value={subCategory.id}>
                                                            {subCategory.name?.ar || subCategory.name?.en || subCategory.title || subCategory.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">قيمة الخصم</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="discountValue"
                                                value={formData.discountValue}
                                                onChange={handleInputChange}
                                                placeholder="أدخل قيمة الخصم"
                                                min="0"
                                                step="0.01"
                                            />
                                        </div>
                                    </>
                                )}

                                {/* Dropdowns ديناميكية حسب النوع */}
                                {formData.type === 'doctor' && (
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">اختر طبيب *</label>
                                        <select
                                            className="form-control"
                                            name="doctor_id"
                                            value={formData.doctor_id}
                                            onChange={handleInputChange}
                                            required
                                            disabled={loadingData}>
                                            <option value="">-- اختر طبيب --</option>
                                            {doctors.map((doctor) => (
                                                <option key={doctor.id} value={doctor.id}>
                                                    {doctor.name || doctor.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                {formData.type === 'pharmacy' && (
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">اختر منتج صيدليات *</label>
                                        <select
                                            className="form-control"
                                            name="product_id"
                                            value={formData.product_id}
                                            onChange={handleInputChange}
                                            required
                                            disabled={loadingData}>
                                            <option value="">-- اختر منتج --</option>
                                            {pharmacyProducts.map((product) => (
                                                <option key={product.id} value={product.id}>
                                                    {product.name || product.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                {formData.type === 'clinic' && (
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">اختر عيادة *</label>
                                        <select
                                            className="form-control"
                                            name="clinic_id"
                                            value={formData.clinic_id}
                                            onChange={handleInputChange}
                                            required
                                            disabled={loadingData}>
                                            <option value="">-- اختر عيادة --</option>
                                            {clinics.map((clinic) => (
                                                <option key={clinic.id} value={clinic.id}>
                                                    {clinic.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                {formData.type === 'sub_category' && (
                                    <>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">اختر الفئة الرئيسية</label>
                                            <select
                                                className="form-control"
                                                name="category_id"
                                                value={formData.category_id}
                                                onChange={handleInputChange}
                                                disabled={loadingData}>
                                                <option value="">-- اختر فئة --</option>
                                                {categories.map((category) => (
                                                    <option key={category.id} value={category.id}>
                                                        {category.name?.ar || category.name?.en || category.title || category.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {formData.category_id && (
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">اختر الفئة الفرعية *</label>
                                                <select
                                                    className="form-control"
                                                    name="sub_category_id"
                                                    value={formData.sub_category_id}
                                                    onChange={handleInputChange}
                                                    required
                                                    disabled={loadingData}>
                                                    <option value="">-- اختر فئة فرعية --</option>
                                                    {subCategories.map((subCategory) => (
                                                        <option key={subCategory.id} value={subCategory.id}>
                                                            {subCategory.name?.ar || subCategory.name?.en || subCategory.title || subCategory.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                    </>
                                )}
                                <div className="col-6 mb-3">
                                    <label className="form-label">الوصف (عربي)</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        name="description_ar"
                                        value={formData.description_ar}
                                        onChange={handleInputChange}
                                        placeholder="أدخل الوصف بالعربية"
                                    />
                                </div>
                                <div className="col-6 mb-3">
                                    <label className="form-label">الوصف (إنجليزي)</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        name="description_en"
                                        value={formData.description_en}
                                        onChange={handleInputChange}
                                        placeholder="Enter English description"
                                    />
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">صورة البانر</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    disabled={imageProcessing}
                                />
                                <small className="text-muted">
                                    اتركه فارغاً للاحتفاظ بالصورة الحالية
                                </small>
                                {imageProcessing && (
                                    <div className="alert alert-info py-2 px-3 mt-2">
                                        جاري تجهيز الصورة، يرجى الانتظار...
                                    </div>
                                )}
                        {imagePreview && !imageProcessing && (
                            <div className="mt-3 text-center">
                                <img
                                    src={imagePreview}
                                    alt="معاينة البانر"
                                    style={{ maxHeight: '180px', maxWidth: '100%', borderRadius: '12px' }}
                                />
                            </div>
                        )}
                            </div>
                            <div className="d-flex justify-content-center gap-2">
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => navigate('/admin-banners')}
                                    disabled={loading}>
                                    إلغاء
                                </motion.button>
                                <motion.button
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                    type="submit"
                                    className="btn text-white"
                                    disabled={loading || imageProcessing}
                                    style={{ backgroundColor: 'rgb(24, 65, 148)' }}>
                                    {loading
                                        ? 'جاري التحديث...'
                                        : imageProcessing
                                            ? 'جاري تجهيز الصورة...'
                                            : 'تحديث البانر'}
                                </motion.button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminEditBanner;
